/*
  Behaviour for the "product.fit" layout (sections/main-product-fit.liquid).
  It only adds presentation on top of the theme's real controls: the variant inputs, the price
  containers and the buy button stay the theme's, and are read or clicked from here.
*/
(function () {
  'use strict';
  var section = document.querySelector('.pdp-fit-section');
  if (!section || section.dataset.pdpFit) return;
  section.dataset.pdpFit = '1';

  var texts = {};
  try { texts = JSON.parse((document.querySelector('[data-pdp-fit-texts]') || {}).textContent || '{}'); } catch (e) {}
  var T = function (k, d) { return texts[k] || d; };
  var clean = function (el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; };
  var num = function (s) {
    var m = String(s || '').match(/[\d.,]*\d/); if (!m) return 0;
    var v = m[0];
    if (/[.,]\d{2}$/.test(v)) v = v.slice(0, -3).replace(/[.,]/g, '') + '.' + v.slice(-2); else v = v.replace(/[.,]/g, '');
    return parseFloat(v) || 0;
  };
  var small = window.matchMedia('(max-width: 768px)');

  /* ---------- price: "20% Off" next to the compare price, kept in sync with the variant ---------- */
  var prices = section.querySelector('.product-single__prices');
  var priceEl = section.querySelector('[data-product-price]');
  var compareEl = section.querySelector('[data-product-price-compare]');
  function syncPrice() {
    if (!prices) return;
    var off = prices.querySelector('.pdp-fit__off');
    var now = num(clean(priceEl)), was = num(clean(compareEl));
    var wrapper = prices.querySelector('[data-price-wrapper]');
    var show = was > now && now > 0 && !(wrapper && wrapper.classList.contains('hide'));
    if (!show) { if (off) off.remove(); }
    else {
      var label = Math.round((1 - now / was) * 100) + T('off', '% Off');
      if (!off) { off = document.createElement('span'); off.className = 'pdp-fit__off'; prices.appendChild(off); }
      if (off.textContent !== label) off.textContent = label;
    }
    syncBuyPrice();
    syncSticky();
  }
  if (prices) new MutationObserver(syncPrice).observe(prices, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });

  /* installments line: shown under the price (it is rendered inside the form by the theme) */
  var terms = section.querySelector('.product-single__form .product__policies');
  var priceBlock = section.querySelector('.product-block--price');
  if (terms && priceBlock && terms.querySelector('shopify-payment-terms')) {
    terms.classList.add('pdp-fit__terms');
    priceBlock.parentNode.insertBefore(terms, priceBlock.nextSibling);
  }

  /* ---------- size row: current value in the label, size chart link on the same row ---------- */
  function syncOptions() {
    [].forEach.call(section.querySelectorAll('.variant-wrapper'), function (wrap) {
      var label = wrap.querySelector('.variant__label'); if (!label || label.classList.contains('hidden-label')) return;
      var sel = wrap.querySelector('select'), radio = wrap.querySelector('input[type="radio"]:checked');
      var value = sel ? sel.value : radio ? radio.value : '';
      var cur = label.querySelector('.pdp-fit__current');
      if (!cur) {
        if (label.querySelector('[data-color-label]')) return;      // the theme already prints the color name
        cur = document.createElement('span'); cur.className = 'pdp-fit__current';
        if (label.firstChild && label.firstChild.nodeType === 3) label.firstChild.textContent = label.firstChild.textContent.replace(/\s+$/, '').replace(/^\s+/, '');
        label.appendChild(document.createTextNode(': ')); label.appendChild(cur);
      }
      if (cur.textContent !== value) cur.textContent = value;
    });
    syncSticky();
  }
  var chart = section.querySelector('.open-tabs_product');
  var firstWrap = section.querySelector('.variant-wrapper');
  if (chart && firstWrap && !firstWrap.contains(chart)) {
    var chartBlock = chart.parentNode;
    firstWrap.appendChild(chart);
    if (chartBlock && chartBlock.classList.contains('product-block') && !chartBlock.textContent.trim()) chartBlock.style.display = 'none';
  }
  section.addEventListener('change', function (e) { if (e.target.closest('.variant-wrapper')) setTimeout(syncOptions, 0); });

  /* ---------- buy button: price inside the button ---------- */
  var buy = section.querySelector('.payment-buttons [data-add-to-cart], [data-add-to-cart]');
  function syncBuyPrice() {
    if (!buy) return;
    var span = buy.querySelector('.pdp-fit__atc-price');
    var price = clean(priceEl);
    if (!price) { if (span) span.remove(); return; }
    if (!span) { span = document.createElement('span'); span.className = 'pdp-fit__atc-price'; buy.appendChild(span); }
    if (span.textContent !== price) span.textContent = price;
  }

  /* ---------- gallery on small screens: next photo peeks in, counter replaces the dots ---------- */
  function gallery() {
    var el = section.querySelector('.product-slideshow.flickity-enabled');
    var F = window.Flickity && el ? window.Flickity.data(el) : null;
    if (!F || el.dataset.pdpFit === String(small.matches)) return !!F;
    el.dataset.pdpFit = String(small.matches);
    var wrap = el.closest('.product__main-photos-wrapper') || el.parentNode;
    var count = wrap.querySelector('.pdp-fit__count');
    if (!count) { count = document.createElement('span'); count.className = 'pdp-fit__count'; count.setAttribute('aria-hidden', 'true'); wrap.appendChild(count); }
    var paint = function () { count.textContent = (F.selectedIndex + 1) + ' / ' + F.cells.length; count.hidden = F.cells.length < 2; };
    if (!el.dataset.pdpFitBound) { el.dataset.pdpFitBound = '1'; F.on('select', paint); }
    paint();
    if (el.dataset.pdpFitAlign === undefined) el.dataset.pdpFitAlign = F.options.cellAlign;
    F.options.cellAlign = small.matches ? 'left' : el.dataset.pdpFitAlign;
    F.resize();
    F.reposition && F.reposition();
    return true;
  }
  /* zoom: tapping a photo (not swiping) opens the theme's zoom for that photo */
  var photos = section.querySelector('.product__main-photos'), down = null;
  if (photos) {
    photos.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; }, true);
    photos.addEventListener('click', function (e) {
      var t = e.target, slide = t.closest && t.closest('.product-main-slide');
      if (!slide || e.defaultPrevented || t.closest('button, a, video, model-viewer, iframe')) return;
      if (down && (Math.abs(e.clientX - down.x) > 8 || Math.abs(e.clientY - down.y) > 8)) return;
      var zoom = slide.querySelector('.js-photoswipe__zoom');
      if (zoom) zoom.click();
    });
  }

  var tries = 0;
  (function waitGallery() { if (!gallery() && tries++ < 40) setTimeout(waitGallery, 250); })();
  (small.addEventListener ? small.addEventListener.bind(small, 'change') : small.addListener.bind(small))(function () { gallery(); });

  /* ---------- accordions: mark the first one so it gets the top rule ---------- */
  var firstTab = section.querySelector('.product-block--tab');
  if (firstTab) {
    firstTab.classList.add('pdp-fit__first-tab');
    var trigger = firstTab.querySelector('.collapsible-trigger');
    if (trigger && !trigger.classList.contains('is-open')) setTimeout(function () { if (!trigger.classList.contains('is-open')) trigger.click(); }, 600);
  }

  /* ---------- trust slider: endless loop, pauses on touch ---------- */
  var trust = section.querySelector('.pdp-trust');
  if (trust && trust.children.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var base = [].slice.call(trust.children);
    for (var i = 0; i < 2; i++) base.forEach(function (li) { var c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); trust.appendChild(c); });
    var setW = function () { return trust.children[base.length].offsetLeft - trust.children[0].offsetLeft; };
    var pos = 0, paused = false, resume, last = 0;
    var wrapPos = function () {
      var w = setW(); if (!w) return;
      if (trust.scrollLeft >= w * 1.5) trust.scrollLeft -= w; else if (trust.scrollLeft < w * 0.5) trust.scrollLeft += w;
      pos = trust.scrollLeft;
    };
    trust.addEventListener('scroll', function () { if (paused) wrapPos(); }, { passive: true });
    var hold = function () { paused = true; clearTimeout(resume); };
    var release = function () { clearTimeout(resume); resume = setTimeout(function () { pos = trust.scrollLeft; paused = false; }, 2500); };
    ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach(function (ev) { trust.addEventListener(ev, hold, { passive: true }); });
    ['pointerup', 'touchend', 'mouseleave', 'focusout'].forEach(function (ev) { trust.addEventListener(ev, release, { passive: true }); });
    var tick = function (t) {
      var w = setW(), dt = Math.min(64, t - last || 16); last = t;
      if (w && !paused && trust.scrollWidth > trust.clientWidth) { pos += dt * 0.03; if (pos >= w * 1.5) pos -= w; if (pos < w * 0.5) pos += w; trust.scrollLeft = pos; }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(function (t) { wrapPos(); tick(t); });
  }

  /* ---------- sticky buy bar: appears when the buy button leaves the screen; it clicks the real button ---------- */
  var sticky = null;
  function syncSticky() {
    if (!sticky || !buy) return;
    var label = buy.querySelector('[data-add-to-cart-text], [class*="span-text"]') || buy;
    var text = clean(label).split(' · ');
    sticky.querySelector('.pdp-sticky__btn').textContent = text[0];
    sticky.querySelector('.pdp-sticky__btn').disabled = buy.disabled;
    var was = clean(compareEl), wrapper = prices && prices.querySelector('[data-price-wrapper]');
    var showWas = was && !(wrapper && wrapper.classList.contains('hide'));
    sticky.querySelector('.pdp-sticky__info b').innerHTML = '';
    sticky.querySelector('.pdp-sticky__info b').appendChild(document.createTextNode(text[1] || clean(priceEl)));
    if (!text[1] && showWas) { var s = document.createElement('s'); s.textContent = was; sticky.querySelector('.pdp-sticky__info b').appendChild(s); }
    var opts = [].map.call(section.querySelectorAll('.variant-wrapper'), function (w) {
      var sel = w.querySelector('select'), r = w.querySelector('input[type="radio"]:checked');
      return sel ? sel.value : r ? r.value : '';
    }).filter(Boolean).join(' / ');
    sticky.querySelector('.pdp-sticky__info span').textContent = opts;
  }
  function initSticky() {
    if (sticky || !buy || !('IntersectionObserver' in window)) return;
    sticky = document.createElement('div');
    sticky.className = 'pdp-sticky';
    sticky.setAttribute('data-off', '');
    sticky.innerHTML = '<div class="pdp-sticky__info"><b></b><span></span></div><button type="button" class="pdp-sticky__btn"></button>';
    document.body.appendChild(sticky);
    sticky.querySelector('.pdp-sticky__btn').addEventListener('click', function () { buy.click(); });
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.bottom < 80;
      if (past) sticky.removeAttribute('data-off'); else sticky.setAttribute('data-off', '');
    }, { rootMargin: '-64px 0px 0px 0px' }).observe(buy);
    new MutationObserver(syncSticky).observe(buy, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    syncSticky();
  }
  initSticky();

  /* ---------- bundle products (Amplify / PickyStory combo): the app draws its own form ----------
     Adds the "Choose your sizes" label row with the size chart link, and points the sticky bar at the app's button. */
  var bundleTries = 0;
  (function waitBundle() {
    var combo = section.querySelector('.picky-combo-container');
    var comboBuy = combo && combo.querySelector('.picky-add-selected-to-cart-button');
    if (!combo || !comboBuy) { if (bundleTries++ < 60) setTimeout(waitBundle, 300); return; }
    if (!section.querySelector('.pdp-fit__bundle-head')) {
      var head = document.createElement('div');
      head.className = 'pdp-fit__bundle-head';
      var label = document.createElement('span');
      label.textContent = T('bundleSizes', 'Choose your sizes');
      head.appendChild(label);
      var link = section.querySelector('.open-tabs_product');
      if (link && !link.closest('.variant-wrapper')) {
        var linkBlock = link.parentNode;
        head.appendChild(link);
        if (linkBlock && linkBlock.classList.contains('product-block') && !linkBlock.textContent.trim()) linkBlock.style.display = 'none';
      }
      combo.parentNode.insertBefore(head, combo);
    }
    /* the app removes the theme's own button, so the sticky bar is rebuilt around the app's button */
    if (buy !== comboBuy) {
      if (sticky) { sticky.remove(); sticky = null; }
      buy = comboBuy;
      initSticky();
      syncBuyPrice();
    }
  })();

  syncPrice();
  syncOptions();
})();
